import { ChartBuilder } from 'Molecules/InsightsChart/chartBuilder';
import { ChartType } from '../chartTypes';
import { BarChartData } from 'Molecules/InsightsChart/chartBuilder';
import { BaseInsightPayload } from '../InsightDataPayload';
import { parseRequestsInReviewPayload } from '../payloads/requestsInReviewPayload';
import { InsightChartFactory } from '../insightChartFactory';
import DefaultChartWithTrendSupport from 'Molecules/InsightsChart/DefaultChartWithTrendSupport';
import intl from 'react-intl-universal';

export const buildRequestsInReviewInsightFactory = (
  payload: BaseInsightPayload
): InsightChartFactory => {
  const parsedPayload = parseRequestsInReviewPayload(payload);
  const { data } = parsedPayload.data.attributes;

  return (props) => {
    const chart = new ChartBuilder()
      .setChartType(ChartType.H_BAR)
      .setProps({
        chartData: data as BarChartData,
        onDrillDown: props.onDrillDown,
        yAxisFieldName: 'days_in_review',
        xAxisFieldNames: ['request_count'],
        legendNames: [intl.get('INSIGHT.LEGEND.REQUEST_COUNT')],
      })
      .build();

    return DefaultChartWithTrendSupport({
      chartComponent: chart,
      trendData: {
        value:
          parsedPayload.data.attributes.aggregate.requests_in_review.current ??
          0,
        trend:
          parsedPayload.data.attributes.aggregate.requests_in_review
            .percentage_change ?? 0,
        trendIsPercent: true,
        description: props.name,
      },
    });
  };
};
